module.exports = __webpack_public_path__ + "img/4.d865dfba.svg";